/* Customer reviews. Named, with the car they actually took delivery of —
   an unattributed quote reads as invented, because usually it is. */

export type Testimonial = {
  id: string
  name: string
  city: string
  vehicle: string
  rating: number
  quote: string
  bank: string
}

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 'ahsan',
    name: 'Ahsan Raza',
    city: 'Islamabad',
    vehicle: 'Toyota Corolla Altis Grande X',
    rating: 5,
    bank: 'UBL',
    quote:
      'They put the same file in front of four banks and showed me all four instalments side by side. I picked the cheapest and had keys in eleven days.',
  },
  {
    id: 'sana',
    name: 'Sana Tariq',
    city: 'Rawalpindi',
    vehicle: 'Suzuki Swift GLX',
    rating: 5,
    bank: 'Bank Alfalah',
    quote:
      'First car on my own name. Nobody talked down to me, and the monthly number on the website was the number on the contract.',
  },
  {
    id: 'bilal',
    name: 'Bilal Chaudhry',
    city: 'Islamabad',
    vehicle: 'KIA Sportage Alpha',
    rating: 5,
    bank: 'Faysal Bank',
    quote:
      'I had been quoted a markup two points higher elsewhere. They explained where the difference came from instead of just insisting theirs was better.',
  },
  {
    id: 'hina',
    name: 'Hina Malik',
    city: 'Wah Cantt',
    vehicle: 'Honda City Aspire',
    rating: 4,
    bank: 'Standard Chartered',
    quote:
      'Approval took a week rather than the promised 48 hours because of my documents, but they chased the bank daily and kept me updated.',
  },
  {
    id: 'usman',
    name: 'Usman Sheikh',
    city: 'Islamabad',
    vehicle: 'Toyota Fortuner Legender',
    rating: 5,
    bank: 'Askari Bank',
    quote:
      'Third car I have taken through them. The reason is simple: they tell you what the total cost over five years is, not just the monthly.',
  },
  {
    id: 'ayesha',
    name: 'Ayesha Noor',
    city: 'Islamabad',
    vehicle: 'MG ZS EV',
    rating: 5,
    bank: 'Bank AL Habib',
    quote:
      'An EV on lease was not straightforward and two banks said no. They found the one that said yes and handled the tracker and insurance too.',
  },
]
